import {connect} from "react-redux";
import HealthCard from "./Card";
import {bindActionCreators} from "redux";
import {healthCard, healthcardDealerProfileData} from "../../../service/Dealer/action";
import {dealerById} from "../../../service/Dealer/action";

const mapStateToProps = (state) => ({
    healthCardRes:state.Dealer.healthCardRes,
    getProfileData:state.Dealer.getProfileData,
    dealerByIdDetails: state.Dealer.dealerById,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            healthCard,
            healthcardDealerProfileData,
            dealerById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(HealthCard);
